import { combineReducers } from 'redux'
import { combineForms } from 'react-redux-form'

import * as h2Api from '../../h2Api'
import * as actions from '../../actions/admin/systemMaintenanceActions'

const indexRequestReducers = actions.indexTypes.reduce((acc, item) => {
  const create = h2Api.restReducer(actions.CREATE_INDEX, {
    actionFilter: action => action.kind === item.kind
  })
  const drop = h2Api.restReducer(actions.DROP_INDEX, {
    actionFilter: action => action.kind === item.kind
  })
  const indexReducerMap = {}

  indexReducerMap._ = h2Api.restReducer(actions.PERFORM_INDEX, {
    actionFilter: action => action.kind === item.kind && action.subKind === '_'
  })

  if (item.subKinds) {
    item.subKinds.forEach(subItem => {
      indexReducerMap[subItem.kind] = h2Api.restReducer(actions.PERFORM_INDEX, {
        actionFilter: action =>
          action.kind === item.kind && action.subKind === item.subKind
      })
    })
    indexReducerMap['*'] = h2Api.restReducer(actions.PERFORM_INDEX, {
      actionFilter: action => action.kind === item.kind && action.subKind === '*'
    })
  }

  //console.log("indexReducerMap for " + item.kind, indexReducerMap);
  const index = combineReducers(indexReducerMap)
  const all = {
    create,
    drop,
    index
  }

  if (item.kind === 'user') {
    all.clear = h2Api.restReducer(actions.CLEAR_USERS)
    all.indexOldManagers = h2Api.restReducer(actions.INDEX_OLD_MANAGERS)
  }

  acc[item.kind] = combineReducers(all)

  //console.log("acc", acc);
  return acc
}, {})

//console.log("index request reducers", indexRequestReducers);

const index = combineReducers({
  requests: combineReducers(indexRequestReducers),
  forms: combineForms(
    {
      indexRestrictions: {
        tenantId: (dynamicValues && dynamicValues.tenantId) || '',
        subTenantId: (dynamicValues && dynamicValues.subTenantId) || '',
        action: '',
        kind: '',
        subKind: '',
        surveyReprocessDryRun: false
      }
    },
    actions.indexFormsRoot
  )
})
const reducer = combineReducers({
  index,
  forms: combineForms(
    {
      s3Roster: {
        location: ''
      }
    },
    'admin.maintenance.forms'
  ),
  s3RosterRequest: h2Api.restReducer(actions.S3_ROSTER),
  usageReportRequest: h2Api.restReducer(actions.ADMIN_MAINTENANCE_USAGE_REPORT),
  schoolRegistrationReportRequest: h2Api.restReducer(
    actions.ADMIN_MAINTENANCE_SCHOOL_REPORT
  ),
  wageCacheRequest: h2Api.restReducer(actions.CACHE_WAGES),
  templateCacheRequestRequest: h2Api.restReducer(actions.DROP_TEMPLATE_CACHE),
  jobOpeningResetRequest: h2Api.restReducer(actions.EXPIRE_JOB_LISTINGS),
  jobOpeningRetrieveRequest: h2Api.restReducer(actions.RETRIEVE_JOB_LISTINGS),
  aeriesSyncUsersRequest: h2Api.restReducer(actions.AERIES_SYNC_USERS),
  aeriesSyncCoursesRequest: h2Api.restReducer(actions.AERIES_SYNC_COURSES),
  psrArchiveRequest: h2Api.restReducer(actions.CREATE_ARCHIVE_PSR),
  reprocessSurveyResponsesRequest: h2Api.restReducer(actions.REPROCESS_SURVEY_RESPONSES)
})

//console.log("systemMaintenanceReducer is", reducer);

export default reducer
